import { useSelector } from 'react-redux';
import { ApplicationState } from '../../rootStore';
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from '@/main/services/reducerUtils';
import { ModelState } from './modelTypes';

export const useModelReducer = (keyReducer: string = 'default') => {
  const returnSelector = useSelector((state: ApplicationState) => state.model);
  if (keyReducer === 'default')
    return returnSelector as IReducerWithIsolated<ModelState>;

  const updateState = {
    ...returnSelector,
    isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA
  };

  return updateState as IReducerWithIsolated<ModelState>;
};
